import React, { ReactElement } from 'react';
import { Global } from '@emotion/react';
import { Select as AntSelect, SelectProps } from 'antd';
import { selectGlobalStyles } from './Select.global.style';

export const InternalSelect = ({ popupClassName, ...rest }: SelectProps): ReactElement => (
  <>
    <Global styles={selectGlobalStyles} />
    <AntSelect popupClassName={['custom-ant-select-dropdown', popupClassName].join(' ')} {...rest} />
  </>
);

export const Select = Object.assign(InternalSelect, {
  Option: AntSelect.Option,
});
